import state from "./state";
import actions from './actions'
import mutations from './mutations'

const identidyInputVerification = {
  namespaced: true,
  state,
  mutations,
  actions
}
export default identidyInputVerification;